(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6732],{

/***/ 78445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-care",
      function () {
        return __webpack_require__(15506);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ virtual_care; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/VirtualCare/TEMP_getInitialProps.ts
var TEMP_getInitialProps = __webpack_require__(728);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/v5/Reason/Download.tsx + 1 modules
var Download = __webpack_require__(67018);
// EXTERNAL MODULE: ./src/components/v5/TestimonialSlider.tsx
var TestimonialSlider = __webpack_require__(97455);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/Insurances.tsx
var Insurances = __webpack_require__(1399);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/VirtualCare/Hero.tsx
var Hero = __webpack_require__(6999);
// EXTERNAL MODULE: ./src/components/v5/VirtualCare/Reasons.tsx
var Reasons = __webpack_require__(41336);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/color/index.js
var node_modules_color = __webpack_require__(32130);
var color_default = /*#__PURE__*/__webpack_require__.n(node_modules_color);
// EXTERNAL MODULE: ./src/hooks/usePrefersReducedMotion.ts
var usePrefersReducedMotion = __webpack_require__(80366);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./src/hooks/useGetSoonestTime.ts
var useGetSoonestTime = __webpack_require__(46102);
// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/_common/LazyComp.tsx
var LazyComp = __webpack_require__(90008);
// EXTERNAL MODULE: ./src/components/v5/VirtualCare/Services.module.scss
var Services_module = __webpack_require__(72702);
var Services_module_default = /*#__PURE__*/__webpack_require__.n(Services_module);
;// CONCATENATED MODULE: ./src/components/v5/VirtualCare/Services.tsx


// @ts-expect-error TS7016: Could not find a declaration file for module 'color'. '/Users/goksel/Sites/carbon-website-next/node_modules/color/index.js' implicitly has an 'any' type.











const time = 20000;
const timeSec = "".concat(time / 1000, "s");
const Services = (param)=>{
    let { imgExt , isMobile , pageLoaded  } = param;
    var _useGetSoonestInPracticeBySpecialtyId, _useGetSoonestInPracticeBySpecialtyId1;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const shouldReduceMotion = (0,usePrefersReducedMotion/* usePrefersReducedMotion */.T)();
    const defaultSlides = [
        {
            specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE,
            head: i18n.t("Everyday Care"),
            text: i18n.t("From preventive to urgent care and everything in between, our virtual care providers are there for you."),
            color: _constants/* vcData */._U[specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE].darker2,
            btnColor: "#FFF",
            // btnBgColor: "#24A06D",
            btnText: i18n.t("Book appointment"),
            img: "vcServices0",
            price: _constants/* vcData */._U[specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE].price,
            firstSlot: (_useGetSoonestInPracticeBySpecialtyId = (0,useGetSoonestTime/* useGetSoonestInPracticeBySpecialtyId */.zn)({
                specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE
            })) === null || _useGetSoonestInPracticeBySpecialtyId === void 0 ? void 0 : _useGetSoonestInPracticeBySpecialtyId.time
        },
        {
            specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_MENTAL_HEALTH */.mg.VIRTUAL_MENTAL_HEALTH,
            head: i18n.t("Mental Health"),
            text: i18n.t("Need to talk things out? Book a virtual session easily through the Carbon Health app. Find a time that works for you and speak to a therapist on your time."),
            color: _constants/* vcData */._U[specialtyIds/* SpecialtyId.VIRTUAL_MENTAL_HEALTH */.mg.VIRTUAL_MENTAL_HEALTH].darker2,
            btnColor: "#FFF",
            // btnBgColor: v5Colors.virtual,
            btnText: i18n.t("Book appointment"),
            img: "vcServices2",
            price: _constants/* vcData */._U[specialtyIds/* SpecialtyId.VIRTUAL_MENTAL_HEALTH */.mg.VIRTUAL_MENTAL_HEALTH].price,
            firstSlot: (_useGetSoonestInPracticeBySpecialtyId1 = (0,useGetSoonestTime/* useGetSoonestInPracticeBySpecialtyId */.zn)({
                specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_MENTAL_HEALTH */.mg.VIRTUAL_MENTAL_HEALTH
            })) === null || _useGetSoonestInPracticeBySpecialtyId1 === void 0 ? void 0 : _useGetSoonestInPracticeBySpecialtyId1.time
        },
        {
            head: i18n.t("Nutritionist "),
            text: i18n.t("We'll work with you to design a nutritional plan that checks off all your boxes."),
            color: palette.darkMint,
            btnColor: palette.gray800,
            img: "vcServices3",
            comingSoon: true
        }
    ];
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [delay, setDelay] = (0,react.useState)(time);
    const [pause, setPause] = (0,react.useState)(true);
    const startTime = Date.now();
    (0,Carbon/* useInterval */.Yz)(()=>{
        if (!isMobile) {
            setActiveIndex((activeIndex + 1) % defaultSlides.length);
        }
    }, delay, pause);
    // @ts-expect-error TS7006: Parameter 'specialtyId' implicitly has an 'any' type.
    const redirectToSpecialty = (specialtyId)=>{
        (0,Carbon/* trackToPatient */.Zr)();
        window.open((0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
            virtual: true,
            specialtyId
        }), "_blank", "noopener,noreferrer");
    };
    (0,react.useEffect)(()=>{
        setDelay(time);
    }, [
        activeIndex
    ]);
    const renderContent = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "dg gac bg-smoke ".concat((Services_module_default()).wrap),
            id: "servicesWrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tac mobileContainer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Services_module_default()).leftInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: i18n.t("Virtual Care, 365 days a year")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Services_module_default()).rows,
                                onMouseEnter: ()=>{
                                    const timeLeft = delay - (Date.now() - startTime);
                                    setDelay(timeLeft);
                                    setPause(true);
                                },
                                onMouseLeave: ()=>{
                                    setPause( false || shouldReduceMotion);
                                },
                                children: defaultSlides.map((param, i)=>/*#__PURE__*/ {
                                    let { specialtyId , head , text , color , btnColor , btnText , img , price , comingSoon , firstSlot  } = param;
                                    return (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((Services_module_default()).row, " ").concat(activeIndex === i ? "active" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Services_module_default()).mobilImg,
                                                style: {
                                                    backgroundImage: "url(/static/img/v5/".concat(img, ".").concat(imgExt, ")")
                                                }
                                            }),
                                            pageLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Services_module_default()).rowSpinner,
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "spinerContainer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "pie spinner",
                                                            style: {
                                                                "--bg": color,
                                                                "--time": timeSec,
                                                                "--state": pause ? "paused" : "running"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "pie filler",
                                                            style: {
                                                                "--bg": color,
                                                                "--time": timeSec,
                                                                "--state": pause ? "paused" : "running"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mask",
                                                            style: {
                                                                "--time": timeSec,
                                                                "--state": pause ? "paused" : "running"
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "df aic bg-inherit p0 mo brdn cp ".concat((Services_module_default()).rowsTW),
                                                onClick: ()=>setActiveIndex(i),
                                                "aria-expanded": activeIndex === i,
                                                "aria-controls": "service-desc-".concat(i),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: (Services_module_default()).rowHead,
                                                        children: head
                                                    }),
                                                    price && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Services_module_default()).rowPrice,
                                                        children: price
                                                    }),
                                                    comingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Services_module_default()).rowSoon,
                                                        children: i18n.t("Coming Soon")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Services_module_default()).rowBody,
                                                id: "service-desc-".concat(i),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "color-nevada fs20 lh12 mt4 lh15",
                                                        children: text
                                                    }),
                                                    btnText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "dig aic mt4 gg8 gg4-md",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                    type: "button",
                                                                    className: "fbce btn bold-f ".concat((Services_module_default()).btn),
                                                                    style: {
                                                                        "--color": btnColor,
                                                                        "--btnBgColor": color,
                                                                        "--btnHoverBg": color_default()(color).lighten(0.2)
                                                                    },
                                                                    onClick: ()=>redirectToSpecialty(specialtyId),
                                                                    onFocus: ()=>setActiveIndex(i),
                                                                    children: [
                                                                        btnText,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "visually-hidden",
                                                                            children: head
                                                                        })
                                                                    ]
                                                                }),
                                                                firstSlot && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (Services_module_default()).times,
                                                                    style: {
                                                                        "--color": _constants/* vcData */._U[specialtyId].darker2
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "desktopOnly",
                                                                            children: i18n.t("Next:")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "bold ml1 ".concat((Services_module_default()).times__inner),
                                                                            children: (0,Carbon/* todayTomorrow2 */.mE)(i18n.lang, firstSlot)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, head);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pos-r desktopOnly",
                    children: defaultSlides.map((s, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(i === activeIndex ? "on" : "", " ").concat((Services_module_default()).rightImg),
                                style: {
                                    backgroundImage: "url(/static/img/v5/".concat(s.img, ".").concat(imgExt, ")")
                                }
                            })
                        }, s.head))
                })
            ]
        });
    return renderContent();
};
/* harmony default export */ var VirtualCare_Services = (Services);

// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
;// CONCATENATED MODULE: ./src/pages/virtual-care.tsx

















const currentSpecialtyId = specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE;
const VirtualCare = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { imgExt , isMobile , practices , csrfToken , locations , pageLoaded , reasons =[]  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const { pathname  } = (0,router.useRouter)();
    // @ts-expect-error TS2339, TS2532, TS2684: Property 'downloadDeepLink' does not exist on type 'RootStatePractice | undefined'.,  Object is possibly 'undefined'.,  The 'this' context of type 'RootStatePractice[] | undefined' is not assignable to method's 'this' of type 'RootStatePractice[]'.
    const { downloadDeepLink  } = practices.findById(practiceIds/* PracticeId.CARBON */.I.CARBON);
    const gA = ()=>isMobile ? (0,api.GA)({
            category: "Download app",
            action: "Branch Link from virtual care scheduling force DL",
            label: currentSpecialtyId
        }) : (0,api.GA)({
            category: "Download app",
            action: "SMS from virtual care scheduling force DL",
            label: currentSpecialtyId
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("Talk to a Doctor Online | Virtual Care at Carbon Health"),
        pageDescription: i18n.t("From preventive to urgent care and everything in between, our virtual care providers are here for you. Connect with a doctor online today."),
        pageImage: "virtual-care",
        navStartTransparent: false,
        style: {
            "--brandColor": _constants/* vcData */._U[currentSpecialtyId].color,
            "--brandColorDarken": _constants/* vcData */._U[currentSpecialtyId].darker,
            "--brandColorDarken2": _constants/* vcData */._U[currentSpecialtyId].darker2,
            "--hero": "linear-gradient(90deg, rgba(53, 56, 61, 0.8) 0%, rgba(70, 72, 73, 0) 75%), url(/static/img/v5/".concat(_constants/* vcData */._U[currentSpecialtyId].hero, ".").concat(imgExt, ")")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                imgExt,
                isMobile,
                downloadDeepLink,
                csrfToken,
                pathname,
                currentSpecialtyId,
                gA
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualCare_Services, {
                imgExt,
                locations,
                pageLoaded,
                isMobile,
                practices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {
                trackingLabel: currentSpecialtyId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reasons/* default */.Z, {
                reasons,
                currentSpecialtyId,
                pageLoaded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurances/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlider/* default */.Z, {})
        ]
    });
};
VirtualCare.getInitialProps = TEMP_getInitialProps/* default */.Z;
/* harmony default export */ var virtual_care = (VirtualCare);


/***/ }),

/***/ 72702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Services_wrap__zSv2x","leftInner":"Services_leftInner__77fgU","rightImg":"Services_rightImg__k7xe3","rows":"Services_rows__Swuj4","row":"Services_row___Rw8i","mobilImg":"Services_mobilImg__YfnYB","rowSpinner":"Services_rowSpinner__we98B","rowHead":"Services_rowHead__KnhTT","rowPrice":"Services_rowPrice__Jc9Dx","rowSoon":"Services_rowSoon__O_qzS","rowBody":"Services_rowBody__mZOUr","times":"Services_times__7pnMx","btn":"Services_btn__j9JJW","rowsTW":"Services_rowsTW__nodxx"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,1439,6282,2122,7018,9908,9774,2888,179], function() { return __webpack_exec__(78445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);